import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '90%',
    padding: '3% 3%',
    margin: 'auto',
  },
  title: {
    width: '100%',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '5px',
    color: '#DF0C36',
    marginBottom: 7,
  },
  contentPaper: {
    width: '100%',
    margin: '0px !important',
    border: '1px solid #CCCCCC',
    borderTop: '2px solid #DF0C36',
  },
  helpDiv: {
    margin: '20px 60px 30px 60px',
  },
  links_list: {
    listStylePosition: 'outside',
    listStyleType: 'disc',
    fontSize: '15px',

    '& li': {
      color: '#DF0C36',
      '& > a': {
        color: '#666666',
        textDecoration: 'underline',
        lineHeight: 2,
      },
      '& a:hover': {
        color: '#DF0C36',
      },
    },
  },
}));
